import { Body } from "@sprout/typography";

import { Stack } from "@sprout/layout.tsx";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Trans } from "react-i18next";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelectAutofill: () => void;
  showWaiting: boolean;
};

const UploadResumeModal = ({ open, onOpenChange, onSelectAutofill, showWaiting }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            <Trans
              i18nKey={
                showWaiting
                  ? "user:resume:upload_modal:analyzing"
                  : "user:resume:upload_modal:title"
              }
            />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="support-modal__body">
            <Stack gap="8px">
              <Body>
                <Trans
                  i18nKey={
                    showWaiting
                      ? "user:resume:upload_modal:waiting"
                      : "user:resume:upload_modal:description"
                  }
                />
              </Body>
            </Stack>
          </div>
        </DialogDescription>
        <DialogFooter>
          <DialogClose>
            <SecondaryButton>
              <Trans
                i18nKey={
                  showWaiting
                    ? "user:resume:upload_modal:cancel"
                    : "user:resume:upload_modal:not_now"
                }
              />
            </SecondaryButton>
          </DialogClose>
          <PrimaryButton onClick={onSelectAutofill} disabled={showWaiting}>
            <Trans i18nKey="user:resume:upload_modal:confirm" />
          </PrimaryButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default UploadResumeModal;
